import {API} from "@/Composables/api";

const getReactions = async (group: string, comment: string, params = {}) => {
    return API.get(route("groups.comments.reactions.index", {group, comment}), params);
};

const storeReaction = async (group: string, comment: string, formData: any, params = {}) => {
    return API.post(route("groups.comments.reactions.store", {group, comment}), params, formData);
};

const updateReaction = async (group: string, comment: string, reaction: string, formData: any, params = {}) => {
    return API.put(route("groups.comments.reactions.update", {group, comment, reaction}), params, formData);
};
const deleteReaction = async (group: string, comment: string, reaction: string, params = {}) => {
    return API.delete(route("groups.comments.reactions.destroy", {group, comment, reaction}), params);
};

export {getReactions, storeReaction, updateReaction, deleteReaction};
